module.exports = __webpack_public_path__ + "assets/images/chef_f01a8cfd5b15c718de6c33a5c5d9e936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/level-bar/chef.png
// module id = 246
// module chunks = 0